import React from 'react';

import { useRecordModal } from 'hooks/useRecordModal';
import { useListContext } from 'react-admin';
import { CurrencyField } from 'shared/react-admin/Fields';
import { MerchantAccountShowDialog } from 'shared/widgets/MerchantAccountShowDialog/MerchantAccountShowDialog';
import { MerchantAccount } from 'types/embedded/merchantAccount';

import { DatagridStyled } from './CumulativeReportSummary.styled';
import { CumulativeReportSummaryField } from './CumulativeReportSummaryField';
import { CumulativeReportSummaryMerchantAccountField } from './CumulativeReportSummaryMerchantAccountField';

export const CumulativeReportSummaryDatagrid = () => {
  const { data: cumulativeReportSummary, isLoading } = useListContext();
  const {
    record: merchantAccount,
    handleCloseRecordModal: handleCloseMerchantAccountModal,
    openRecordModal: openMerchantAccountModal,
    handleOpenRecordModal: handleOpenShowDialog,
  } = useRecordModal<MerchantAccount>();

  return (
    <>
      <DatagridStyled
        bulkActionButtons={false}
        data={cumulativeReportSummary}
        isLoading={isLoading}
      >
        <CumulativeReportSummaryMerchantAccountField
          label="Счет мерчанта"
          onClick={handleOpenShowDialog}
          source="merchantAccountName"
        />
        <CurrencyField
          alphaCodeSource="merchantAccountCurrencyCode"
          label="Валюта счета"
          nameSource="merchantAccountCurrencyName"
          source="merchantAccountCurrencyCode"
        />
        <CumulativeReportSummaryField
          label="Пополнения"
          originalValueKey="originalPaymentAmount"
          source="originalPaymentAmount"
          summaryColor="success.main"
          valueKey="paymentAmount"
        />
        <CumulativeReportSummaryField
          label="Выводы"
          originalValueKey="originalPayoutAmount"
          source="originalPayoutAmount"
          summaryColor="error.main"
          valueKey="payoutAmount"
        />
        <CumulativeReportSummaryField
          label="Рефанды"
          originalValueKey="originalRefundAmount"
          source="originalRefundAmount"
          valueKey="refundAmount"
        />
        <CumulativeReportSummaryField
          label="Чарджбеки"
          originalValueKey="originalChargebackAmount"
          source="originalChargebackAmount"
          valueKey="chargebackAmount"
        />
        <CumulativeReportSummaryField
          label="Комиссия за пополнение"
          originalValueKey="originalCommissionPaymentValue"
          source="originalCommissionPaymentValue"
          valueKey="commissionPaymentValue"
        />
        <CumulativeReportSummaryField
          label="Комиссия за выводы"
          originalValueKey="originalCommissionPayoutValue"
          source="originalCommissionPayoutValue"
          valueKey="commissionPayoutValue"
        />
        <CumulativeReportSummaryField
          label="Комиссия за рефанды"
          originalValueKey="originalCommissionRefundValue"
          source="originalCommissionRefundValue"
          valueKey="commissionRefundValue"
        />
        <CumulativeReportSummaryField
          label="Комиссия за чарджбеки"
          originalValueKey="originalCommissionChargebackValue"
          source="originalCommissionChargebackValue"
          valueKey="commissionChargebackValue"
        />
        <CumulativeReportSummaryField
          label="Итого за период"
          originalValueKey="originalTotalAmount"
          source="originalTotalAmount"
          valueKey="totalAmount"
        />
      </DatagridStyled>
      {merchantAccount && (
        <MerchantAccountShowDialog
          merchantAccount={merchantAccount}
          onClose={handleCloseMerchantAccountModal}
          open={openMerchantAccountModal}
        />
      )}
    </>
  );
};
